import { Component, computed, ElementRef, ViewChild } from '@angular/core';
import { AppMenu } from './app.menu';
import { LayoutService } from '@/layout/service/layout.service';
import { RouterModule } from '@angular/router';
import { AppTopbar } from '@/layout/components/app.topbar';
import { CommonModule } from '@angular/common';

@Component({
    selector: '[app-sidebar]',
    standalone: true,
    imports: [CommonModule, AppMenu, RouterModule, AppTopbar],
    host: { class: 'block lg:hidden' },
    template: ` <div class="layout-sidebar bg-white border-r border-slate-200" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
        <!-- <div class="sidebar-header bg-white px-6 py-4 border-b border-slate-200">
            <div class="flex items-center justify-between">
                <a class="logo" [routerLink]="['/']">
                    <img class="logo-image w-[120px] transition-all duration-200" 
                         src="/images/lojinha-logo-slogan.png" 
                         alt="Lojinha Libbs" />
                </a>
                <button class="layout-sidebar-anchor z-2 w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 transition-colors" 
                        type="button" 
                        (click)="anchor()">
                    <i class="pi pi-bars text-slate-600"></i>
                </button>
            </div>
        </div> -->

        <div #menuContainer class="layout-menu-container py-4">
            <div app-menu></div>
        </div>
        <div app-topbar *ngIf="isHorizontal()"></div>
    </div>`,
    styles: [
        `
            :host {
                .layout-sidebar {
                    @apply shadow-sm;

                    .sidebar-header {
                        .layout-sidebar-anchor {
                            &:hover {
                                @apply bg-slate-100;
                            }
                        }
                    }
                }
            }
        `
    ]
})
export class AppSidebar {
    timeout: any = null;

    isHorizontal = computed(() => this.layoutService.isHorizontal());

    menuTheme = computed(() => this.layoutService.layoutConfig().menuTheme);

    @ViewChild('menuContainer') menuContainer!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef
    ) {}

    onMouseEnter() {
        if (!this.layoutService.layoutState().anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.layoutService.layoutState.update((state) => {
                if (!state.sidebarActive) {
                    return {
                        ...state,
                        sidebarActive: true
                    };
                }
                return state;
            });
        }
    }

    onMouseLeave() {
        if (!this.layoutService.layoutState().anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.layoutService.layoutState.update((state) => {
                        if (state.sidebarActive) {
                            return {
                                ...state,
                                sidebarActive: false
                            };
                        }
                        return state;
                    });
                }, 300);
            }
        }
    }

    anchor() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            anchored: !state.anchored
        }));
    }
}
